module.exports = __webpack_public_path__ + "static/media/Lumberjack.ec28ed7c.jpg";